import { render } from "./Insert.vue?vue&type=template&id=72e61f07&scoped=true"
import script from "./Insert.vue?vue&type=script&lang=js"
export * from "./Insert.vue?vue&type=script&lang=js"

import "./Insert.vue?vue&type=style&index=0&id=72e61f07&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72e61f07"

export default script